import { apiSlice } from 'src/rtk/api/apiSlice';
import * as traineeDashboardUrl from 'src/helpers/url_helper';

export const traineeDashboardApi = apiSlice
  .enhanceEndpoints({
    addTagTypes: [
      'TraineeDashboard',
      'SupervisorDashboard',
      'CompletedTrainingWorkshops',
    ],
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      getTraineeDashboardInfo: builder.query<APIResponse<any>, void>({
        query: () => ({
          method: 'GET',
          url: `${traineeDashboardUrl.GET_TRAINEE_DASHBOARD_INFO}`,
        }),

        providesTags: ['TraineeDashboard'],
      }), 

      getSupervisorDashboardInfo: builder.query<APIResponse<any>, void>({
        query: () => ({
          method: 'GET',
          url: `${traineeDashboardUrl.GET_SUPERVISOR_DASHBOARD_INFO}`,
        }),

        providesTags: ['SupervisorDashboard'],
      }),

      getCompletedTrainingWorkshops: builder.query<APIResponse<any>, void>({
        query: () => ({
          method: 'GET',
          url: traineeDashboardUrl.COMPLETED_TRAINING_WORKSHOP,
        }),
        providesTags: ['CompletedTrainingWorkshops'],
      }),

      createCompletedTrainingWorkshop: builder.mutation<APIResponse<any>, FormData>({
        query: (formData) => ({
          method: 'POST',
          url: traineeDashboardUrl.COMPLETED_TRAINING_WORKSHOP,
          body: formData,
        }),
        invalidatesTags: ['CompletedTrainingWorkshops'],
      }),

      deleteCompletedTrainingWorkshop: builder.mutation<APIResponse<any>, string>({
        query: (id) => ({
          method: 'DELETE',
          url: `${traineeDashboardUrl.COMPLETED_TRAINING_WORKSHOP}/${id}`,
        }),
        invalidatesTags: ['CompletedTrainingWorkshops'],
      }),
    }),
  });

export const {
  useGetTraineeDashboardInfoQuery,
  useGetSupervisorDashboardInfoQuery,
  useGetCompletedTrainingWorkshopsQuery,
  useCreateCompletedTrainingWorkshopMutation,
  useDeleteCompletedTrainingWorkshopMutation,
} = traineeDashboardApi;
